import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-blue-950" data-id="element-107" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-108" data-mp="223ekniyd552e">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-slate-50 border border-amber-500/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg" data-id="element-109" data-mp="222d797tvk6hi">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-amber-500" data-id="element-110" data-mp="1j4agooloi1hl" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-white text-amber-500 mb-8 border border-amber-500/30" data-id="element-111" data-mp="1edtzcteqlvpy">
            <ShieldCheck size={48} data-id="element-112" data-mp="qmyd0bt1vsq3" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-blue-950" data-id="element-113" data-mp="lpg3aj77l9h1">
            🛡️ 7-Day Refund Policy
          </h2>
          <div className="space-y-6 text-lg text-slate-700 max-w-2xl mx-auto" data-id="element-114" data-mp="oyqdq8ixhvj5">
            <p data-id="element-115" data-mp="txt88z1a8jcv">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-blue-950" data-id="element-116" data-mp="ypb81jrkkdw9">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact our support team within the applicable
              period and we will review the case according to our refund policy.
            </p>
            <p className="text-sm text-slate-500 mt-8" data-id="element-117" data-mp="b0s055cfm34p">
              The product is delivered digitally in PDF format.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}